import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.Campaign = class Campaign extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-campaign-unit';
	}

	constructor(element) {
		super(element);
	}

	render() {
		this.setVars();
		this.setAppearence();
	}

	setVars() {
		this.fontColor = this.$element.data('fontColor') || '#000';
		this.backgroundColor = this.$element.data('backgroundColor') || '#FFF';
		this.adType = this.$element.data('type');
		this.position = this.$element.data('position').toLowerCase();
		this.$title = this.$element.find('.fa-campaign-unit__title');
		this.$content = this.$element.find('.fa-content-promo__content');
		this.$colPositioner = this.$element.find('.col-positioner');
	}

	setAppearence() {
		if (this.adType === 'complex') {
			this.$content.css({
				backgroundColor: this.backgroundColor,
				borderColor: this.fontColor,
				color: this.fontColor
			});
		}
		
		this.$title.css('color', this.fontColor);
		
		if (this.position) {
			this.setPosition();
		}
	}
	
	setPosition() {
		if (this.position === 'center') {
			this.$colPositioner.addClass('col-sm-offset-3');
		}
		
		if (this.position === 'right') {
			this.$colPositioner.addClass('col-sm-offset-5');
		}
	}
};



// WEBPACK FOOTER //
// ./components/campaign/scripts/campaign.js